module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'collisionsIndex'
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("flare")]), _vm._v(" "), _c('span', [_vm._v("Collisions")])])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-toggle",
    on: {
      "click": function($event) {
        return _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("gavel")]), _vm._v(" "), _c('span', [_vm._v("City Council Districts")]), _c('i', {
    staticClass: "material-icons nav-toggle-arrow"
  }, [_vm._v("keyboard_arrow_right")])]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'cityCouncilDistricts'
      }
    }
  }, [_c('span', [_vm._v("List")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'cityCouncilDistrictRanksIndex'
      }
    }
  }, [_c('span', [_vm._v("Ranks")])])], 1)])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-toggle",
    on: {
      "click": function($event) {
        return _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("nature_people")]), _vm._v(" "), _c('span', [_vm._v("Neighborhood")]), _c('i', {
    staticClass: "material-icons nav-toggle-arrow"
  }, [_vm._v("keyboard_arrow_right")])]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'neighborhoods'
      }
    }
  }, [_c('span', [_vm._v("List")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'neighborhoodRanksIndex'
      }
    }
  }, [_c('span', [_vm._v("Ranks")])])], 1)])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "nav-toggle",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggle($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("info_outline")]), _vm._v(" "), _c('span', [_vm._v("About")]), _c('i', {
    staticClass: "material-icons nav-toggle-arrow"
  }, [_vm._v("keyboard_arrow_right")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/blog/the-story"
    }
  }, [_c('span', [_vm._v("The Story")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog/the-data"
    }
  }, [_c('span', [_vm._v("The Data")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog/the-technology"
    }
  }, [_c('span', [_vm._v("The Technology")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog/media-coverage"
    }
  }, [_c('span', [_vm._v("In The Media")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/blog/todo"
    }
  }, [_c('span', [_vm._v("To Do")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/blog"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("library_books")]), _vm._v(" "), _c('span', [_vm._v("Blog")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40aa51d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 429
// module chunks = 1